import { BaseEntity } from '@shared/entity/base-entity';
import { Field } from '@tsim/model';

export class BaseRootEntity extends BaseEntity {
  @Field(String, true)
  _id!: string;

  @Field(Date, true)
  createdAt = new Date();

  @Field(Date, true)
  updatedAt = new Date();
}
